import { useQuery } from '@apollo/client';
import type { UseDealRboInfoFetch } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import { GetDealRboInfoDocument } from '../../../graphql/query/deals/GetDealRboInfo.generated';

export const useDealRboInfoFetch: UseDealRboInfoFetch = ({ dealId, skip }) => {
  const { data, loading } = useQuery(GetDealRboInfoDocument, {
    skip,
    fetchPolicy: 'network-only',
    variables: {
      dealId,
    },
  });

  return {
    loading,
    rboInfo: data?.dealRboInfo ?? [],
  };
};
